import { ButtonProps } from "@mui/material";
import colors from "theme/base/colors";
import VidletButton from "./VidletButton";

export default function SaveButton({ children, sx, ...props }: ButtonProps) {
  return (
    <VidletButton
      sx={{
        backgroundColor: colors.saveButton.main,
        "&:hover": {
          backgroundColor: colors.primary.light,
        },
        ...sx,
      }}
      {...props}
    >
      {children || "SAVE"}
    </VidletButton>
  );
}
